

 //--
import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";
 //#region comment metod

 

 const DeleteMenu = (data: any) =>
 request({
   url: ApiURL.Command.DeleteMenu+"/"+data+"/delete",
   method: RequestType.DELETE,
  });

 const PostMenuAdd = (data: any) =>
 request({
   url: ApiURL.Command.PostMenuAdd,
   method: RequestType.POST,
   data,
 });
 const PostMenuCopy = (data: any) =>
 request({
   url: ApiURL.Command.PostMenuCopy,
   method: RequestType.POST,
   data,
 });
 const PostMenuItemRoleAdd = (data: any) =>
 request({
   url: ApiURL.Command.PostMenuItemRoleAdd,
   method: RequestType.POST,
   data,
 });
 const PutMenuUpdate = (data: any) =>
 request({
   url: ApiURL.Command.PutMenuUpdate,
   method: RequestType.PUT,
   data,
 });
 const PutMenuApplicationUpdate = (data: any) =>
 request({
   url: ApiURL.Command.PutMenuApplicationUpdate,
   method: RequestType.PUT,
   data,
 });
 const DeleteMenuApplication = (data: any) =>
 request({
   url: ApiURL.Command.DeleteMenuApplication+"/"+data+"/delete",
   method: RequestType.DELETE,
  });
  const PostMenuApplicationAdd = (data: any) =>
  request({
    url: ApiURL.Command.MenuApplicationAdd,
    method: RequestType.POST,
    data,
  });

 
const MenuCommand = {
    DeleteMenu,
    PostMenuAdd,
    PostMenuCopy,
    PostMenuItemRoleAdd, 
    PutMenuUpdate,
    PutMenuApplicationUpdate,
    DeleteMenuApplication,
    PostMenuApplicationAdd

};

export default MenuCommand;
